import { Component, OnInit, input } from '@angular/core';
import { DecisionDto, LogDto } from '@coin/importer/dto/util';

@Component({
  selector: 'importer-import-decision',
  templateUrl: './import-decision.component.html',
  styleUrls: ['./import-decision.component.scss'],
  standalone: false
})
export class ImportDecisionComponent implements OnInit {
  public readonly data = input<LogDto>(undefined);
  public decision: DecisionDto;

  constructor() {}

  ngOnInit(): void {
    this.decision = this.data()?.decision;
  }
}
